var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 9.25H12.25V1.75H1.75V9.25ZM13 0.25H1C0.58525 0.25 0.25 0.586 0.25 1V10C0.25 10.414 0.58525 10.75 1 10.75H4L2.65 12.55C2.401 12.8815 2.4685 13.3517 2.8 13.6C2.935 13.7012 3.0925 13.75 3.24925 13.75C3.478 13.75 3.703 13.6465 3.85 13.45L5.875 10.75H6.25V13C6.25 13.414 6.58525 13.75 7 13.75C7.41475 13.75 7.75 13.414 7.75 13V10.75H8.125L10.15 13.45C10.297 13.6465 10.522 13.75 10.7508 13.75C10.9075 13.75 11.065 13.7012 11.2 13.6C11.5315 13.3517 11.599 12.8815 11.35 12.55L10 10.75H13C13.4148 10.75 13.75 10.414 13.75 10V1C13.75 0.586 13.4148 0.25 13 0.25Z",
    fill: "#EF3340"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenRed);
export default __webpack_public_path__ + "static/media/ScreenRed.e393ee54efa14f015a6fa8a330d435e4.svg";
export { ForwardRef as ReactComponent };